import { AsyncPipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { TradeCreateQuoteComponentBase } from '@zero/trade/feature-trade/base';

@Component({
  selector: 'trade-create-quote',
  templateUrl: './trade-create-quote.component.html',
  styleUrls: ['./trade-create-quote.component.scss'],
  imports: [BlinkDirective, AsyncPipe, DecimalPipe, TranslocoPipe],
})
export class TradeCreateQuoteComponent extends TradeCreateQuoteComponentBase {}
